import { DateRange } from "react-day-picker";

export enum DatePickerMode {
  SINGLE = 'single',
  RANGE = 'range'
}

export type DatePickerValue = Date | DateRange | string;